import { render, staticRenderFns } from "./orderComponent.vue?vue&type=template&id=1d6bd542&scoped=true&"
import script from "./orderComponent.vue?vue&type=script&lang=ts&"
export * from "./orderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6bd542",
  null
  
)

export default component.exports